import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { PrivacyActions } from './privacy.actions';

@Injectable({
  providedIn: 'root'
})
export class PrivacyEffects {
  sendPrivacyEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendPrivacyEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(PrivacyActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
